import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrichadmin.admin.pipeline');
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-nrichadmin-admin-pipeline',
template: templateSource || '',
    styles: [``],
})
export class PortalNrichadminAdminPipelineComponent implements OnInit, OnDestroy {
    // ── 상태 카드 ──
    public status: any = {};
    public loading: boolean = true;

    // ── 문서 목록 ──
    public documents: any[] = [];
    public totalDocs: number = 0;
    public page: number = 1;
    public dump: number = 15;
    public searchText: string = "";
    public statusFilter: string = "";

    // ── SSE 파이프라인 실행 ──
    public runningDocId: string = "";
    public pipelineLog: any[] = [];
    public pipelineRunning: boolean = false;
    private abortController: AbortController | null = null;

    // ── 상세 모달 ──
    public detailDoc: any = null;
    public detailPipeline: any = null;
    public showDetail: boolean = false;

    // ── 수정 모달 ──
    public editDoc: any = null;
    public showEdit: boolean = false;

    // ── 업로드 ──
    public uploading: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadStatus();
        await this.loadDocuments();
    }

    ngOnDestroy() {
        this.cancelRun();
    }

    // ── 상태 카드 로드 ──────────────────────────────────

    public async loadStatus() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call("pipeline_status_detail");
        if (code === 200) {
            this.status = data;
        }
        this.loading = false;
        await this.service.render();
    }

    public get total() {
        return (this.status.pending || 0) + (this.status.processing || 0) +
               (this.status.ready || 0) + (this.status.error || 0);
    }

    public percentage(value: number): number {
        return this.total > 0 ? Math.round(value / this.total * 100) : 0;
    }

    // ── 문서 목록 ───────────────────────────────────────

    public async loadDocuments(pg: number = 1) {
        this.page = pg;
        const { code, data } = await wiz.call("pipeline_documents", {
            text: this.searchText,
            status: this.statusFilter,
            page: this.page,
            dump: this.dump,
        });
        if (code === 200) {
            this.documents = data.list || [];
            this.totalDocs = data.total || 0;
        }
        await this.service.render();
    }

    public async searchDocs() {
        await this.loadDocuments(1);
    }

    public async filterByStatus(s: string) {
        this.statusFilter = this.statusFilter === s ? "" : s;
        await this.loadDocuments(1);
    }

    public get lastPage(): number {
        return Math.max(1, Math.ceil(this.totalDocs / this.dump));
    }

    public get pages(): number[] {
        const result: number[] = [];
        const start = Math.max(1, this.page - 2);
        const end = Math.min(this.lastPage, this.page + 2);
        for (let i = start; i <= end; i++) result.push(i);
        return result;
    }

    // ── 문서 상세 ───────────────────────────────────────

    public async openDetail(doc: any) {
        const { code, data } = await wiz.call("pipeline_detail", { document_id: doc.id });
        if (code === 200) {
            this.detailDoc = data.document;
            this.detailPipeline = data.state;
            this.showDetail = true;
        }
        await this.service.render();
    }

    public closeDetail() {
        this.showDetail = false;
        this.detailDoc = null;
        this.detailPipeline = null;
    }

    // ── 문서 삭제 ───────────────────────────────────────

    public async deleteDocument(doc: any) {
        const res = await this.service.alert.show({
            title: "문서 삭제",
            message: `"${doc.title || doc.pdf_name}"을(를) 삭제하시겠습니까?\nDB 레코드, 추출 파일, 벡터 데이터가 모두 삭제됩니다.`,
            action: "삭제",
            actionBtn: "error",
            cancel: "취소",
        });
        if (!res) return;

        const { code, data } = await wiz.call("pipeline_delete", { document_id: doc.id });
        if (code === 200) {
            await this.service.alert.show({
                title: "삭제 완료",
                message: `페이지 ${data.deleted_pages}건, 객체 ${data.deleted_objects}건, 작업 ${data.deleted_jobs}건 삭제됨`,
                action: "확인",
            });
        } else {
            await this.service.alert.show({
                title: "삭제 실패",
                message: data?.message || "삭제 중 오류가 발생했습니다.",
                actionBtn: "error",
                action: "확인",
            });
        }

        this.closeDetail();
        await this.loadStatus();
        await this.loadDocuments(this.page);
    }

    // ── 문서 수정 ───────────────────────────────────────

    public openEdit(doc: any) {
        this.editDoc = { ...doc };
        this.showEdit = true;
    }

    public closeEdit() {
        this.showEdit = false;
        this.editDoc = null;
    }

    public async saveEdit() {
        if (!this.editDoc) return;
        const { code, data } = await wiz.call("pipeline_update", {
            document_id: this.editDoc.id,
            title: this.editDoc.title || "",
            category: this.editDoc.category || "",
            region: this.editDoc.region || "",
            period: this.editDoc.period || "",
            department: this.editDoc.department || "",
            access_level: this.editDoc.access_level || "public",
            publish_year: this.editDoc.publish_year || "",
        });
        if (code === 200) {
            this.closeEdit();
            // 상세 모달이 열려있으면 갱신
            if (this.showDetail && this.detailDoc?.id === this.editDoc?.id) {
                this.detailDoc = data;
            }
            await this.loadDocuments(this.page);
        } else {
            await this.service.alert.show({
                title: "수정 실패",
                message: data?.message || "수정 중 오류가 발생했습니다.",
                actionBtn: "error",
                action: "확인",
            });
        }
    }

    // ── 파이프라인 실행 (SSE) ───────────────────────────

    public async runPipeline(doc: any, step?: string) {
        if (this.pipelineRunning) return;
        this.runningDocId = doc.id;
        this.pipelineLog = [];
        this.pipelineRunning = true;
        this.abortController = new AbortController();
        await this.service.render();

        const params: any = { document_id: doc.id };
        if (step) params.step = step;

        const formData = new FormData();
        for (const [k, v] of Object.entries(params)) {
            formData.append(k, String(v));
        }

        try {
            const response = await fetch(
                `/wiz/api/page.admin/pipeline_run_sse`,
                { method: 'POST', body: formData, signal: this.abortController.signal }
            );
            const reader = response.body!.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n\n');
                buffer = lines.pop() || '';

                for (const line of lines) {
                    if (line.startsWith('data: ')) {
                        try {
                            const event = JSON.parse(line.slice(6));
                            this.pipelineLog.push(event);
                            await this.service.render();
                        } catch {}
                    }
                }
            }
        } catch (err: any) {
            if (err.name !== 'AbortError') {
                this.pipelineLog.push({ type: "error", message: `연결 오류: ${err.message}` });
            }
        }

        this.pipelineRunning = false;
        await this.service.render();
        // 완료 후 목록 갱신
        await this.loadStatus();
        await this.loadDocuments(this.page);
    }

    // ── 일괄 실행 (SSE) ─────────────────────────────────

    public async runBatch() {
        if (this.pipelineRunning) return;

        const pendingCount = this.status.pending || 0;
        if (pendingCount === 0) {
            await this.service.alert.show({
                title: "일괄 실행",
                message: "대기 중인 문서가 없습니다.",
                action: "확인",
            });
            return;
        }

        const res = await this.service.alert.show({
            title: "일괄 실행",
            message: `대기 중인 문서 ${pendingCount}건을 일괄 처리하시겠습니까?`,
            action: "실행",
            cancel: "취소",
        });
        if (!res) return;

        this.pipelineLog = [];
        this.pipelineRunning = true;
        this.runningDocId = "batch";
        this.abortController = new AbortController();
        await this.service.render();

        const formData = new FormData();
        formData.append("status", "pending");

        try {
            const response = await fetch(
                `/wiz/api/page.admin/pipeline_run_batch`,
                { method: 'POST', body: formData, signal: this.abortController.signal }
            );
            const reader = response.body!.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n\n');
                buffer = lines.pop() || '';

                for (const line of lines) {
                    if (line.startsWith('data: ')) {
                        try {
                            const event = JSON.parse(line.slice(6));
                            this.pipelineLog.push(event);
                            await this.service.render();
                        } catch {}
                    }
                }
            }
        } catch (err: any) {
            if (err.name !== 'AbortError') {
                this.pipelineLog.push({ type: "error", message: `연결 오류: ${err.message}` });
            }
        }

        this.pipelineRunning = false;
        await this.service.render();
        await this.loadStatus();
        await this.loadDocuments(this.page);
    }

    public cancelRun() {
        if (this.abortController) {
            this.abortController.abort();
            this.abortController = null;
        }
        this.pipelineRunning = false;
    }

    // ── 재시도 ──────────────────────────────────────────

    public async retryPipeline(doc: any, step?: string) {
        await this.runPipeline(doc, step);
    }

    // ── PDF 업로드 ──────────────────────────────────────

    public triggerUpload() {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = ".pdf";
        input.multiple = true;
        input.onchange = async (e: any) => {
            const files = e.target.files;
            if (!files || files.length === 0) return;
            await this.uploadFiles(files);
        };
        input.click();
    }

    public async uploadFiles(files: FileList) {
        this.uploading = true;
        await this.service.render();

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const formData = new FormData();
            formData.append("file", file);
            formData.append("title", file.name.replace(/\.pdf$/i, ""));

            try {
                const resp = await fetch(`/wiz/api/page.admin/pipeline_upload`, {
                    method: 'POST',
                    body: formData,
                });
                const result = await resp.json();
                if (result.code !== 200) {
                    await this.service.alert.show({
                        title: "업로드 실패",
                        message: result.data?.message || "업로드 중 오류가 발생했습니다.",
                        actionBtn: "error",
                        action: "확인",
                    });
                }
            } catch (err: any) {
                await this.service.alert.show({
                    title: "업로드 실패",
                    message: err.message,
                    actionBtn: "error",
                    action: "확인",
                });
            }
        }

        this.uploading = false;
        await this.loadStatus();
        await this.loadDocuments(1);
    }

    // ── PDF 다운로드 ────────────────────────────────────

    public downloadPdf(doc: any) {
        window.open(`/wiz/api/page.admin/pipeline_download?document_id=${doc.id}`, "_blank");
    }

    // ── 유틸 ────────────────────────────────────────────

    public statusColor(s: string): string {
        const map: any = {
            pending: 'bg-gray-100 text-gray-700',
            processing: 'bg-blue-100 text-blue-700',
            ready: 'bg-green-100 text-green-700',
            completed: 'bg-green-100 text-green-700',
            error: 'bg-red-100 text-red-700',
            failed: 'bg-red-100 text-red-700',
        };
        return map[s] || 'bg-gray-100 text-gray-700';
    }

    public statusLabel(s: string): string {
        const map: any = {
            pending: '대기',
            processing: '처리중',
            ready: '완료',
            completed: '완료',
            error: '오류',
            failed: '실패',
        };
        return map[s] || s;
    }

    public stepLabel(s: string): string {
        const map: any = {
            step1: 'PDF 추출',
            metadata: '메타데이터',
            step2: '벡터 적재',
            step3: 'KG 구축',
        };
        return map[s] || s;
    }

    public stepNum(s: string): string {
        const map: any = {
            step1: '1',
            metadata: '2',
            step2: '3',
            step3: '4',
        };
        return map[s] || '?';
    }

    public logIcon(type: string): string {
        const icons: any = {
            status: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 text-blue-600"><path stroke-linecap="round" stroke-linejoin="round" d="M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.58-5.84a14.927 14.927 0 0 1-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"/></svg>',
            step_start: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 text-indigo-600"><path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5"/></svg>',
            progress: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 text-gray-600"><path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182"/></svg>',
            step_done: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 text-green-600"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/></svg>',
            step_error: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 text-red-600"><path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/></svg>',
            warning: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 text-yellow-600"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"/></svg>',
            done: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 text-green-700"><path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"/></svg>',
            error: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 text-red-700"><path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/></svg>',
            info: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 text-blue-500"><path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"/></svg>',
            batch_start: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 text-indigo-700"><path stroke-linecap="round" stroke-linejoin="round" d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 0 1 0 3.75H5.625a1.875 1.875 0 0 1 0-3.75Z"/></svg>',
            batch_progress: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 text-indigo-500"><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"/></svg>',
            batch_done: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 text-green-700"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/></svg>',
            batch_error: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 text-orange-600"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"/></svg>',
        };
        return icons[type] || '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 text-gray-400"><circle cx="12" cy="12" r="9"/></svg>';
    }

    public logColor(type: string): string {
        const map: any = {
            status: 'text-blue-600',
            step_start: 'text-indigo-600',
            progress: 'text-gray-600',
            step_done: 'text-green-600',
            step_error: 'text-red-600',
            warning: 'text-yellow-600',
            done: 'text-green-700',
            error: 'text-red-700',
            info: 'text-blue-500',
            batch_start: 'text-indigo-700 font-semibold',
            batch_progress: 'text-indigo-500 font-medium',
            batch_done: 'text-green-700 font-semibold',
            batch_error: 'text-orange-600',
        };
        return map[type] || 'text-gray-600';
    }

    public readonly STEPS = ['step1', 'metadata', 'step2', 'step3'];
}

export default PortalNrichadminAdminPipelineComponent;